import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { formShell } from "@/lib/api";

// /form/{token} → hosted inside the owning dealer's page shell (?view=form&t=token). Keeps ?pick= pre-selections.
export default function PublicFormPage() {
  const { token } = useParams();
  const [slug, setSlug] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    formShell(token).then((r) => setSlug(r.dealer_slug || "orevital")).catch((e) => setError(e?.response?.data?.detail || "This form link isn't valid"));
  }, [token]);
  if (error) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center px-6" data-testid="form-error">
        <div className="max-w-md text-center">
          <h1 className="text-xl font-semibold text-[#0b2545]">This link isn't available</h1>
          <p className="mt-2 text-sm text-zinc-600">{error}</p>
          <a href="/d/orevital" className="inline-block mt-5 text-sm font-semibold text-[#0b2545] underline">Go to OreVital</a>
        </div>
      </div>
    );
  }
  if (!slug) return <div className="min-h-[60vh] flex items-center justify-center" data-testid="form-loading"><Loader2 className="animate-spin text-[#0b2545]" size={28} /></div>;
  const q = new URLSearchParams(window.location.search);
  q.set("view", "form");
  q.set("t", token);
  return <Navigate to={`/d/${slug}?${q.toString()}`} replace />;
}
